export const RESET = 'TICKET_UPDATE_RESET'
export const SET_ERROR = 'TICKET_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'TICKET_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'TICKET_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'TICKET_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'TICKET_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'TICKET_UPDATE_UPDATE_RETRIEVED'
